var React = require('react');

function FlagGayMlm (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#3d1a78","d":"M0,0H35V21H0z","key":0}),React.createElement("path",{"fill":"#5049cc","d":"M0,0H35V18H0z","key":1}),React.createElement("path",{"fill":"#7bade2","d":"M0,0H35V15H0z","key":2}),React.createElement("path",{"fill":"#fff","d":"M0,0H35V12H0z","key":3}),React.createElement("path",{"fill":"#98e8c1","d":"M0,0H35V9H0z","key":4}),React.createElement("path",{"fill":"#26ceaa","d":"M0,0H35V6H0z","key":5}),React.createElement("path",{"fill":"#078d70","d":"M0,0H35V3H0z","key":6})]);
}

FlagGayMlm.defaultProps = {"viewBox":"0 0 35 21","width":"1200","height":"720"};

module.exports = FlagGayMlm;

FlagGayMlm.default = FlagGayMlm;
